import type ChatViewState from '../store/schema/ChatViewState';
import ChatState from '../store/schema/ChatState';
import getMySipUri from '../../presenceManager/getMySipUri';
import getUserDisplayName from 'owa-session-store/lib/selectors/getUserDisplayName';
import { orchestrator } from 'satcheljs';
import { addChat, setChatState, updateParticipantDisplayName } from '../actions/ucmaActions';
import { getVisibleChats, getMoreChats } from '../chatManager/chatFilters';

const MAX_SHOWN_CHAT_COUNT = 4;

orchestrator(addChat, actionMessage => {
    const { chat } = actionMessage;
    onChatStateChanged(chat);
});

orchestrator(setChatState, actionMessage => {
    const { chat } = actionMessage;
    onChatStateChanged(chat);
});

function onChatStateChanged(chat: ChatViewState) {
    const activeChats = getVisibleChats();
    const moreChats = getMoreChats();
    if (activeChats.length > MAX_SHOWN_CHAT_COUNT) {
        const chatToHide = activeChats.filter(activeChat => activeChat != chat)[0];
        if (chatToHide) {
            setChatState(chatToHide, ChatState.InMoreMenu);
        }
    } else if (activeChats.length < MAX_SHOWN_CHAT_COUNT && moreChats.length > 0) {
        setChatState(moreChats[0], ChatState.Normal);
    }

    // Always make sure myself is in the participant cache when add a chat
    updateParticipantDisplayName(getMySipUri(), getUserDisplayName());
}
